// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"415":"3f5216ab","787":"382a662a"}[chunkId] + ".chunk.js";
};